import {User} from './user.model';

export class SimpleUserInfo {

    token: string;
    email: string;
    name: string;

    constructor(token: string, email: string, name: string) {
        this.token = token;
        this.email = email;
        this.name = name;
    }
}
